import {any} from 'ramda';
import {isNotNilOrEmpty} from 'ramda-adjunct';

import {BusinessCaseOnlineOfferResponseBody} from '../../../api/types/onlineOfferTypes';

export type ReservationPriceFields = Partial<
  Pick<
    BusinessCaseOnlineOfferResponseBody,
    | 'upsell'
    | 'totalPriceWithVat'
    | 'totalPriceWithoutVat'
    | 'totalDiscountPriceWithVat'
    | 'totalDiscountPriceWithoutVat'
    | 'vehiclePriceWithVat'
    | 'vehiclePriceWithoutVat'
    | 'originalCarPriceWithVat'
    | 'originalCarPriceWithoutVat'
  >
>;

/**
 * Whether the offer carries any price at all. Selling reservation cards use
 * this to avoid an empty card, while buying cards use it to show a price-on-request
 * placeholder.
 */
export function hasReservationPrices(offer: ReservationPriceFields) {
  return any(isNotNilOrEmpty, [
    offer.upsell,
    offer.totalPriceWithVat,
    offer.totalPriceWithoutVat,
    offer.totalDiscountPriceWithVat,
    offer.totalDiscountPriceWithoutVat,
    offer.vehiclePriceWithVat,
    offer.vehiclePriceWithoutVat,
    offer.originalCarPriceWithVat,
    offer.originalCarPriceWithoutVat,
  ]);
}
